import {
  EppsCustomFieldDecimalTypes,
  EppsCustomFieldTypes
} from "./epps-models";
const NSSampleCustomFields = [
  {
    epassCustomFieldId: 7177,
    newFieldId: "LR.CX.10",
    originalFieldId: "CX.10",
    description: "Multiselect",
    type: EppsCustomFieldTypes.DROPDOWN,
    editable: false,
    hidden: true,
    masterList: ["Option 1", "Option 2", "Option 3", "Option 4"]
  },
  {
    epassCustomFieldId: 7178,
    newFieldId: "LR.CX.12",
    originalFieldId: "CX.12",
    description: "LenderPaidMortgageInsuranceIndicator",
    type: EppsCustomFieldTypes.YN,
    editable: false,
    hidden: true,
    masterList: ["Y", "N"]
  },
  {
    epassCustomFieldId: 7179,
    newFieldId: "LR.CX.13",
    originalFieldId: "CX.13",
    description: "Boolean",
    type: EppsCustomFieldTypes.DROPDOWNLIST,
    editable: false,
    hidden: true,
    masterList: ["True", "False"]
  },
  {
    epassCustomFieldId: 7180,
    newFieldId: "LR.CX.15",
    originalFieldId: "CX.15",
    description: "cust 15",
    type: EppsCustomFieldTypes.X,
    editable: false,
    hidden: true,
    masterList: ["X"]
  },
  {
    epassCustomFieldId: 7181,
    newFieldId: "LR.CX.VARENO",
    originalFieldId: "CX.VARENO",
    description: "VA Renovation Loan Indicator",
    type: EppsCustomFieldTypes.DROPDOWNLIST,
    editable: false,
    hidden: true,
    masterList: ["VA Reno", "VA", "Term"]
  },
  {
    epassCustomFieldId: 7182,
    newFieldId: "LR.CX.123",
    originalFieldId: "CX.123",
    description: "Text Box",
    type: EppsCustomFieldTypes.STRING,
    editable: false,
    hidden: true,
    masterList: []
  },
  {
    epassCustomFieldId: 7183,
    newFieldId: "LR.1771",
    originalFieldId: "1771",
    description: "Trans Details Down Pmt %",
    type: EppsCustomFieldDecimalTypes.DECIMAL_3,
    editable: false,
    hidden: true,
    masterList: []
  },
  {
    epassCustomFieldId: 7184,
    newFieldId: "LR.CX.11",
    originalFieldId: "CX.11",
    description: "String",
    type: EppsCustomFieldTypes.STRING,
    editable: false,
    hidden: true,
    masterList: []
  },
  {
    epassCustomFieldId: 7185,
    newFieldId: "LR.358",
    originalFieldId: "358",
    description: "Subject Property Value for LTV",
    type: EppsCustomFieldDecimalTypes.DECIMAL_2,
    editable: false,
    hidden: true,
    masterList: []
  },
  {
    epassCustomFieldId: 7186,
    newFieldId: "LR.CX.130",
    originalFieldId: "CX.130",
    description: "Decimal2",
    type: EppsCustomFieldDecimalTypes.DECIMAL_2,
    editable: false,
    hidden: true,
    masterList: []
  },
  {
    epassCustomFieldId: 7187,
    newFieldId: "LR.CX.1234",
    originalFieldId: "CX.1234",
    description: "state",
    type: EppsCustomFieldTypes.STATE,
    editable: false,
    hidden: true,
    masterList: []
  },
  {
    epassCustomFieldId: 7188,
    newFieldId: "LR.233",
    originalFieldId: "233",
    description: "Expenses Proposed HOA",
    type: EppsCustomFieldDecimalTypes.DECIMAL_2,
    editable: false,
    hidden: true,
    masterList: []
  },
  {
    epassCustomFieldId: 7189,
    newFieldId: "LR.101",
    originalFieldId: "101",
    description: "Income Borr Base Income",
    type: EppsCustomFieldDecimalTypes.DECIMAL_2,
    editable: false,
    hidden: true,
    masterList: []
  },
  {
    epassCustomFieldId: 7190,
    newFieldId: "LR.CX.999",
    originalFieldId: "CX.999",
    description: "TEXT",
    type: EppsCustomFieldTypes.STRING,
    editable: false,
    hidden: true,
    masterList: []
  },
  {
    epassCustomFieldId: 7191,
    newFieldId: "LR.1240",
    originalFieldId: "1240",
    description: "Borr Email",
    type: EppsCustomFieldTypes.STRING,
    editable: false,
    hidden: true,
    masterList: []
  },
  {
    epassCustomFieldId: 7192,
    newFieldId: "LR.CX.TEXTFIELD936",
    originalFieldId: "CX.TEXTFIELD936",
    description: "Text Field for Smoke Test",
    type: EppsCustomFieldTypes.STRING,
    editable: false,
    hidden: false,
    masterList: []
  },
  {
    epassCustomFieldId: 7193,
    newFieldId: "LR.CX.TEXTFIELD582",
    originalFieldId: "CX.TEXTFIELD582",
    description: "Text Field for Smoke Test",
    type: EppsCustomFieldTypes.STRING,
    editable: false,
    hidden: false,
    masterList: []
  }
];
export {
  NSSampleCustomFields
};
